import { render, staticRenderFns } from "./guardian.vue?vue&type=template&id=4d60a632&scoped=true"
import script from "./guardian.vue?vue&type=script&lang=js"
export * from "./guardian.vue?vue&type=script&lang=js"
import style0 from "./guardian.vue?vue&type=style&index=0&id=4d60a632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60a632",
  null
  
)

export default component.exports